module.exports = __webpack_public_path__ + "static/media/slides_0.20493191.JPG";